const METADATA_FIELD_TYPES = [
  'text',
  'date',
  'datetime',
  'drop_down',
  'email',
  'float',
  'integer',
  'string_exact',
  'string',
  'tag_cloud',
  'boolean',
  '__separator__',
  'url',
] as const;

export type MetadataFieldType = (typeof METADATA_FIELD_TYPES)[number];

const metadataFieldTypeSet: ReadonlySet<string> = new Set(METADATA_FIELD_TYPES);

export const isMetadataFieldType = (
  value: string,
): value is MetadataFieldType => metadataFieldTypeSet.has(value);
